import {Button, Divider} from '@mui/material'
import CustomDialog from '../../genericComponents/customDialog/CustomDialog'
import {SearchItem} from '../../search/model/SearchItem'
import {useCurrentGuildContext, useDatxPathGenerator} from '../../util/routing'
import {useDeleteItemsFromItemListMutation} from '../rtkItemListApi'
import {UpdatedItemList} from '../model/UpdatedItemList'
import {ROUTES} from '../../constants/routing'
import {useNavigate} from 'react-router-dom'
import {ItemList} from '../model/ItemList'

function DeleteItemFromListDialog({
                                      open,
                                      closeDialog,
                                      currentList,
                                      itemsToDelete
                                  }: {
    open: boolean
    closeDialog: () => void
    itemsToDelete: SearchItem[]
    currentList: ItemList | null | undefined
}) {
    const [currentGuildContext] = useCurrentGuildContext()
    const [updateItemList, updateItemListResult] = useDeleteItemsFromItemListMutation()

    const generatePath = useDatxPathGenerator()
    const navigate = useNavigate()

    const onSubmit = () => {
        if (!currentGuildContext || !currentList) {
            return
        }
        const {id, name} = currentList
        const itemsToDeleteIDs = itemsToDelete.map((item) => item.id)

        const guildId = currentGuildContext.guildId
        const updatedItemList: UpdatedItemList = {id, name, guildId, items: itemsToDeleteIDs}

        updateItemList({listId: id, data: updatedItemList})
            .unwrap()
            .then(() => navigate(generatePath(ROUTES.manageItemLists.path)))
    }

    return (
        <CustomDialog className="delete-item-list-dialog" open={open} title="Confirmation" onClose={closeDialog}>
            <div>
                <p className="delete-item-list-dialog-text">Delete the selected items from the list?</p>
                <Divider sx={{mt: 5, mb: 2}}/>

                <div className="delete-items-dialog-buttons">
                    <Button className="delete-item-list-back-button" onClick={() => closeDialog()}>
                        Cancel
                    </Button>

                    <Button
                        className="delete-item-list-submit"
                        color="primary"
                        variant="contained"
                        onClick={onSubmit}
                        disabled={updateItemListResult.isLoading}
                        loading={updateItemListResult.isLoading}
                        data-testid="delete-button"
                    >
                        Delete selected items
                    </Button>
                </div>
            </div>
        </CustomDialog>
    )
}

export default DeleteItemFromListDialog
